<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate *ngIf="ac !== null">

    <div class="p-grid">
        <div class="p-col-6">
            <h2>{{ t('common.labels.basedata') }}</h2>
        </div>
        <div class="p-col-6 p-text-right" *ngIf="inEdit !== true">
            <button withRight="admin.ac.edit" *ngIf="ac.not_yet_started" pButton (click)="onEdit()" type="button" label="{{ t('common.labels.edit') }}" icon="pi pi-pencil" class="p-button-sm p-mb-2 autofocus"></button>
            <button *ngIf="items.length > 0" pButton type="button" (click)="menu.toggle($event)" icon="pi pi-bars" class="p-button-outlined p-button-secondary p-button-sm p-mb-2 p-ml-2" aria-label="{{ t('common.labels.more_functions') }}"></button>
            <p-menu #menu [popup]="true" [model]="items"></p-menu>
        </div>
        <div class="p-col-6 p-text-right" *ngIf="inEdit === true">
          <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
        </div>
    </div>

    <app-loader [loading]="loading === true"></app-loader>

    <ng-container *ngIf="loading !== true">
      <div class="p-grid p-fluid">
          <div class="p-col-12 p-md-6">
            <app-form-control [cid]="'name'" [control]="form.get('name')" [type]="'input'" [label]="t('common.labels.name')" [edit]="inEdit" [basevalue]="ac.name"></app-form-control>
            <app-form-control [cid]="'start_time'" [control]="form.get('start_time')" [type]="'date'" [label]="t('common.labels.date') + getDstLabel()" [edit]="inEdit" [basevalue]="ac.start_time_admin | amDateFormat: 'DD.MM.YYYY - HH:mm'"></app-form-control>
            <div class="p-grid">
              <div class="p-col-3">
                <app-form-control [cid]="'location_type'" [control]="form.get('location_type')" [type]="'select'" [options]="locationTypes" [label]="t('common.labels.type')" [edit]="inEdit" [basevalue]="ac.location_type"></app-form-control>
              </div>
              <div class="p-col-9">
                <app-form-control [cid]="'location_name'" [control]="form.get('location_name')" [type]="'input'" [label]="t('common.labels.place')" [edit]="inEdit" [basevalue]="ac.location_name"></app-form-control>
              </div>
            </div>
            <app-country-timezone [edit]="inEdit" [required]="true" [(country)]="country" [(timezone)]="timezone" [form]="form.get('tz')"></app-country-timezone>
          </div>
          <div class="p-col-12 p-md-6">
            <app-form-control [cid]="'dispatcher'" [control]="form.get('dispatcher')" [type]="'select'" [options]="dispatchers" optionLabel="fullname_reverse" [label]="t('common.labels.dispatcher')" [edit]="inEdit" [basevalue]="ac.dispatcher_name"></app-form-control>
            <app-form-control withFeature="customers" [cid]="'customer'" [control]="form.get('customer')" [type]="'select'" [options]="customers" optionLabel="name" [label]="t('common.labels.customer')" [edit]="inEdit" [basevalue]="ac.customer_name | dashWhenEmpty" [showClear]="true"></app-form-control>
            <app-form-control [cid]="'language'" [control]="form.get('language')" [type]="'select'" [options]="languages" [label]="t('common.labels.language')" [edit]="inEdit" [basevalue]="t(ac.getLanguageName())"></app-form-control>
            <app-form-control [cid]="'ratingtype'" [control]="form.get('ratingtype')" [type]="'select'" [options]="ratingtypes" [optionLabel]="'name.' + transloco.getActiveLang().toUpperCase()" [label]="t('common.labels.ratingtype')" [edit]="inEdit" [basevalue]="ac.ratingtype?.getLang('name', transloco.getActiveLang())"></app-form-control>
          </div>
      </div>

      <hr>

      <h2>{{ t('common.labels.conference_dial_in') }}</h2>
      <div class="p-grid p-fluid">
          <div class="p-col-12 p-md-6">
            <app-form-control [cid]="'conference_url'" [control]="form.get('conference_url')" [type]="'input'" [label]="t('common.labels.url')" [edit]="inEdit" [basevalue]="ac.conference_url"></app-form-control>
          </div>
          <div class="p-col-12 p-md-6">
            <app-form-control [cid]="'conference_info'" [control]="form.get('conference_info')" [type]="'textarea'" [label]="t('common.labels.informations')" [edit]="inEdit" [basevalue]="ac.conference_info"></app-form-control>
          </div>
      </div>

      <hr>

      <h2>{{ t('common.labels.informations') }}</h2>
      <div class="p-grid p-fluid">
          <div class="p-col-12 p-md-6">
            <app-form-control [cid]="'informations_internal'" [control]="form.get('informations_internal')" [type]="'textarea'" [label]="t('common.labels.informations_internal')" [edit]="inEdit" [basevalue]="ac.informations_internal"></app-form-control>
          </div>
          <div class="p-col-12 p-md-6">
            <app-form-control [cid]="'informations_moderator'" [control]="form.get('informations_moderator')" [type]="'textarea'" [label]="t('common.labels.informations_moderator')" [edit]="inEdit" [basevalue]="ac.informations_moderator"></app-form-control>
          </div>
      </div>

      <hr>

      <h2>{{ t('common.labels.settings') }}</h2>
      <div class="p-grid p-fluid">
          <div class="p-col-12 p-md-6">
            <app-form-control [cid]="'documents_visible_observer'" [control]="form.get('documents_visible_observer')" [type]="'checkbox'" [label]="t('ac_basedata.documents_visible_observer')" [edit]="inEdit" [basevalue]="ac.documents_visible_observer"></app-form-control>
          </div>
      </div>

    </ng-container>

  </form>

  <div class="form-footer">
    <p>{{ t('common.labels.created_at') }} {{ ac.created_at | amLocal | amDateFormat: 'DD.MM.YYYY - HH:mm' }} {{ t('common.labels.oclock') }}, {{ t('common.labels.updated_at') }} {{ ac.updated_at | amLocal | amDateFormat: 'DD.MM.YYYY - HH:mm' }} {{ t('common.labels.oclock') }}</p>
  </div>

</ng-container>
